<!--
 * @Description  : 购票须知中的带富文本展示的展示框
-->

<template minapp="mpx" xlang="wxml">
  <view class="content-explain">
    <view class="title">
      <image wx:if="{{!explainValue.noIcon}}" class="title-icon" src="{{iconSrc}}"></image>
      <view class="title-text">{{ explainValue.title }}</view>
    </view>

    <view class="caption">
      <view class="caption-icon">
        <image
          wx:if="{{!explainValue.noIcon}}"
          class="caption-image"
          src="https://dpubstatic.udache.com/static/dpubimg/wrn-rZGc7HA4aqLe5wW8z.png"
        ></image>
      </view>
      <view class="caption-text">
        <view wx:for="{{explainValue.listText}}" wx:key="index" class="caption-text-item">
          <rich-text nodes="{{item}}"></rich-text>
        </view>
      </view>
    </view>

    <view wx:if="{{explainValue.prompt}}" class="prompt">{{ explainValue.prompt }}</view>
    <view wx:if="{{ explainValue.tip }}" class="tip">{{ explainValue.tip }}</view>
    <slot name="{{'tabrefund'}}"></slot>
    <slot name="{{'other'}}"></slot>
    <image wx:if="{{isShowTabIcon}}" class="tab-icon" src="{{imgSrc}}"></image>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      title: {
        type: String,
        value: '温馨提示'
      },
      listText: {
        type: Array,
        value: () => []
      },
      explainValue: {
        type: Object,
        value: () => {}
      },
      isShowTabIcon:{
        type: Boolean,
        value:false
      }
    },
    data() {
      return {
        iconSrc: 'https://dpubstatic.udache.com/static/dpubimg/q9hniug5T__r0nB2gQrLx.png',
        imgSrc: 'https://dpubstatic.udache.com/static/dpubimg/tuXMEH7OgWQGSylGuPx0R.png'
      }
    }
  })
</script>

<style scoped lang="stylus">
  .content-explain
    position relative
    border-radius 8px
    opacity 1
    display flex
    flex-direction column
    // padding 0px
    box-sizing border-box
    /* 纯白 */
    background #FFFFFF
    .title
      display flex
      height 46px
      align-items center
      margin 0 12px 12px 12px
      border-bottom 0.5px rgba(0, 0, 0, 0.08) solid
      .title-icon
        width 18px
        height 18px
      .title-text
        margin-left 4px
        height 19px
        opacity 1
        font-family PingFangSC-Medium
        font-size 16px
        font-weight normal
        line-height 19px
        letter-spacing 0px
        /* 1品牌/01蓝 */
        color #1473FF
    .caption
      margin 0 12px
      display flex
      .caption-image
        width 18px
        height 18px
        margin-right 4px
        flex none
      .caption-text
        font-family PingFangSC-Regular
        font-size 14px
        font-weight normal
        line-height 18px
        letter-spacing 0px
        flex 1
        .caption-text-item
          margin-bottom 8px
          &:last-child
            margin-bottom 12px
    .prompt
      margin 0 12px 12px
      box-sizing border-box
      padding 8px 10px
      background #FFF4EE
      color #FF7D41
      border-radius 8px
      font-family PingFangSC-Regular
      font-size 12px
      font-weight normal
      line-height 18px
      letter-spacing 0px
    .tip
      font-family PingFangSC-Regular
      font-size 14px
      font-weight normal
      line-height 18px
      letter-spacing 0px
      color #666666
      margin 0 12px 12px 34px
      ::before
        content ''
        display inline-block
        width 4px
        height 4px
        background #999
        border-radius 100%
        vertical-align middle
        margin-right 5px

    .tab-icon
      position absolute
      right 8px
      top 6.6px
      width 48px
      height 50.4px
      opacity 1
      z-index 2
</style>

<script name="json">
  module.exports = {
    component: true
  }
</script>